import React from 'react';


const ImageGrid = () => {
  // Array de ejemplo con las URLs de tus imágenes
  // Puedes reemplazar esto con tus propias imágenes
  const images = [
    '/images/premio_a_opt.webp',
    '/images/premio_b_opt.webp',
    '/images/premio_c_opt.webp',
    '/images/premio_d_opt.webp',
    '/images/premio_e_opt.webp',
    '/images/premio_f_opt.webp',
    '/images/premio_g_opt.webp',
    '/images/premio_h_opt.webp',
    '/images/premio_i_opt.webp',
  ];

  return (
    <div className="image-grid-container">
      {images.map((imageUrl, index) => (
        <div key={index} className="image-item">
          <img src={imageUrl} alt={`Imagen ${index + 1}`} />
        </div>
      ))}
    </div>
  );
};

export default ImageGrid;